import TaskTable from './TaskTable'

export { TaskTable } from './TaskTable'
export default TaskTable;


// WEBPACK FOOTER //
// ./src/components/TaskTable/index.js